// src/api/recruiter/Profile/useGetProfile.ts
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../../firebase/firebase";
import { collection, query, where, getDocs, limit } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { RecruiterInterface } from "./dto";

const getRecruiterProfileInfo = async (
  uid: string | undefined
): Promise<RecruiterInterface> => {
  if (!uid) {
    throw new Error("No user ID provided.");
  }

  const q = query(
    collection(db, "user_infos"),
    where("uid", "==", uid),
    limit(1)
  );

  const snap = await getDocs(q);
  if (snap.empty) {
    throw new Error("No recruiter found with UID: " + uid);
  }

  return snap.docs[0].data() as RecruiterInterface;
};

export const useGetRecruiterProfileInfo = (
  uid: string | undefined
) => {
  return useQuery<RecruiterInterface, AxiosError>({
    queryKey: [QueryKeys.RECRUITER, uid],
    queryFn: () => getRecruiterProfileInfo(uid!),
    enabled: Boolean(uid),
    retry: 1,
  });
};
